import {ApplicationRef, Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Store} from "@ngrx/store";

import * as appContext from 'src/app/store/appcontext';
import {NavSections} from "./NavSections";
import {Auth, Authorizations, Globals} from "./Globals";
import {Observable, Subject, BehaviorSubject} from "rxjs";
import {AuthorizeService} from "../api-authorization/authorize.service";



@Injectable({
  providedIn: 'root'
})
export class GlobalContextService {

  private readonly url: string;
  private  validValues = false;
  private callGetUser = true;

  private userInfoInitializedSubject = new BehaviorSubject<boolean>(false);
  public userInfoInitialized$ = this.userInfoInitializedSubject.asObservable();
  
  globals: Globals= { email:"", userType: 0, clientID:0, clientName: "", userID:"",userName: "", Auths: []};
  Auths: number[] = [];

  constructor( private http:HttpClient, 
               @Inject('BASE_URL') baseUrl: string,
               private store: Store<any>,
               private appRef: ApplicationRef
               //,private Auth:AuthorizeService
             ) {
    //console.log("in GlobalContextService constructor");
    this.url = baseUrl;

    for (let i in Authorizations) {
      let ss = Authorizations[i].Title;
      //alert(ss);
      let fnd = Authorizations.find(x => x.Title == ss);
      if (fnd != undefined) {
        if (fnd.id != Authorizations[i].id) {
          alert("Duplicate Title in Authorizations at " + fnd.id + " and " + Authorizations[i].id);
        }
      }
      
    }
    for (let i in Authorizations) {
      let ss = Authorizations[i].id;
      //alert(ss);
      let fnd = Authorizations.find(x => x.id == ss);
      if (fnd != undefined) {
        if (fnd.Title != Authorizations[i].Title) {
          alert("Duplicate id in Authorizations at " + fnd.id);
        }
      }

    }
    //alert("finished checking for duplicates")
  }

  public async GetUserInfo()  {
    
    console.log("in GetUserInfo about to get the user info");
    this.http.get<Globals>(this.url + 'api/UserInfo').subscribe(resp => {
      //console.log("got user info:" + resp);
      this.globals = resp;
      //console.log(this.globals);
      //this.store.dispatch(appContext.loggedInUserInfo({ item: this.globals }));
      //this.validValues = true;
      
      
      this.http.get<Auth[]>(this.url + 'api/Authorizations/User/' + this.globals.userID).subscribe(resp => {
        //console.log("got user authorizatons:" + resp);
        this.Auths = resp.map(x => (x.Authorization));
        this.globals.Auths = this.Auths;
        //console.log(this.Auths);
        this.store.dispatch(appContext.loggedInUserInfo({item: this.globals}));
        this.validValues = true;
        this.userInfoInitializedSubject.next(true);
      });
    });
    
  }

  public async GetUserInfo2() {
/*    if (!this.Auth.isAuthenticated()) {
      //need to retrieve the user from the store
      let user = this.Auth.getUser();
      console.log("tried to get user:" + user);
    }*/
    
    //console.log("in GetUserInfo2 about to get the user info");
    let response = await fetch(this.url + 'api/UserInfo');
    if (response === undefined) {
      //console.log("responce from UserInfo is null");
    }
    let resp = await response.json();
    //console.log("got user info:" + resp);
    if (resp == null) return;
    this.globals = JSON.parse(resp);
    
    let response2 = await fetch(this.url + 'api/Authorizations/User/' + this.globals.userID);
    let resp2 = await response2.json();
    //console.log("got user authorizatons:" + resp2);
    this.Auths = resp.map(x => (x.Authorization));
    this.globals.Auths = this.Auths;
    //console.log(this.Auths);
    this.store.dispatch(appContext.loggedInUserInfo({item: this.globals}));
    this.validValues = true;
    //this.appRef.tick();
  }
  
/*  CheckHasUserInfo() {
    if (this.Auths.length == 0 || (!this.callGetUser && !this.validValues)) {
      this.callGetUser = true;
    }
  }*/
  
  private async GetAuthsFromStore() {
    if (this.callGetUser ) {
      this.callGetUser = false;
      await this.GetUserInfo2().then(() => {});
    }

/*    let j = 0
    while (this.globals.Auths.length == 0 && j < 5) {
      let i = 0;
      while (this.globals.Auths.length == 0 && i < 5) {
        i = i + 1;
        setTimeout(() => {
          console.log(i);
        }, 1000)
      }
      
      this.GetUserInfo().then(() => {});
      j = j + 1;
    }*/
    this.Auths = this.globals.Auths;
  }
  
  public isRoleAuthorized(id: number) {
    if (this.Auths[0] == -1) return true;
    return this.Auths.find(x => x == id);
  }
  
  public isAuthorized(name: string) {
    if (name == 'true') return true;
    
    if (this.Auths != undefined && this.Auths.length == 0) {
      this.validValues = true;
      this.GetAuthsFromStore();
    }

    if (this.Auths[0] == -1) return true;
    if (name.length == 0) return false;
    
    let auths = name.split("|");
    
    for (let authn of auths) {
      let auth = Authorizations.find(x => x.Title == authn);
      if (auth == undefined) alert("could not find authorization:" + authn);
      let found = this.Auths.find(x => x == auth.id);
      if ( found != undefined) return true;
    }
    
    return false;
    
  }
  
  public GetAuthorizationLevels() {
    return [...new Set(Authorizations.map(item => item.group))];
  }
  
  public GetAuthorizations(level: string) {
    return Authorizations.filter(x => x.group == level)
  }
  
/*  public GetValidValues() {
    return this.validValues;
  }*/
  
  public IsDataforensicsUser() {
    return this.globals.userType && NavSections.dataforensics
  }
  
  public SetClientName(ClientName: string) {
    this.globals.clientName = ClientName;
    this.store.dispatch(appContext.loggedInUserInfo({ item: this.globals }));

    this.nameChange.next(this.globals.clientName);
  }
  
  public  GetClientName() {
    //alert("userType =" + this.globals.userType);
    if (this.globals.userType == 0) {
       this.store.select(appContext.selectAppContextState).subscribe(async x => {
        this.globals = x;
        // might have been lost in refresh so get again
        if (this.globals.userType == 0) {
          await this.GetUserInfo2();
          //console.log(this.globals);
          return this.globals.clientName;
        }
        return this.globals.clientName;
      });
    }
    //alert("userName:" + this.globals.clientName);
    return this.globals.clientName;
  }

  public  GetClientID() {
    //alert("userType =" + this.globals.userType);
    if (this.globals.userType == 0) {
       this.store.select(appContext.selectAppContextState).subscribe(async x => {
        this.globals = x;
        // might have been lost in refresh so get again
        if (this.globals.userType == 0) {
          await this.GetUserInfo2();
          //console.log(this.globals);
          return this.globals.clientID;
        }
        return this.globals.clientID;
      });
    }
    //alert("userName:" + this.globals.clientName);
    return this.globals.clientID;
  }
  
  public  GetUserType() {
     if (this.globals.userType == 0) {
       this.store.select(appContext.selectAppContextState).subscribe(async x => { 
           this.globals = x;
           // might have been lost in refresh so get again
           if (this.globals.userType == 3) {
             await this.GetUserInfo2();
             //console.log(this.globals);
             return this.globals.userType
           }
          return this.globals.userType
     });
    }
    return this.globals.userType;
}

  nameChange: Subject<string> = new Subject<string>();

}
